import { formatInTimeZone } from "date-fns-tz";
import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import DateRangeComp from "../../common/DateRangeComp";
import { MemberList } from "../../memberlist/components/MemberList";
import * as actions from "../redux/VipEvaluateAction";

export const VipEvaluate = ({}) => {
  const [swalProps, setSwalProps] = useState({});
  const intl = useIntl();
  const dispatch = useDispatch();
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const startOfYesterday = new Date(yesterday.setHours(0, 0, 0, 0));
  const endOfYesterday = new Date(yesterday.setHours(23, 59, 59, 999));
  const [fromDate, setFromDate] = useState(startOfYesterday);
  const [toDate, setToDate] = useState(endOfYesterday);
  const [selMemberId, setSelMemberId] = useState(null);
  const [selectedDirectionBaseOn, setSelectedDirectionBaseOn] = useState("");
  const [memberSettingPermission, setMemberSettingPermission] = useState("");

  const timeZone = "Asia/Kuala_Lumpur";
  const vipEvaluateState = useSelector(
    ({ vipEvaluate }) => vipEvaluate,
    shallowEqual
  );
  const queryParamsRef = useRef({});

  useEffect(() => {
    dispatch(
      actions.fetchVipEvaluateUI({
        action: "vipevaluateUI",
      })
    ).then((resp) => {
      resp = resp.data;
      setSelectedDirectionBaseOn(resp.directionBaseOnLists[0].code);
      handleSearchClick(resp.directionBaseOnLists[0].code);
    });

    return () => {
      dispatch(actions.clearVipEvaluateList());
    };
  }, []);

  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
  };

  const handleSearchClick = (directionbaseon, isClear) => {
    queryParamsRef.current = {
      action: "vipevaluate",
      fromdate: formatInTimeZone(fromDate, timeZone, "yyyy-MM-dd"),
      todate: formatInTimeZone(toDate, timeZone, "yyyy-MM-dd"),
      directionbaseon: directionbaseon ?? selectedDirectionBaseOn,
    };
    dispatch(
      actions.fetchVipEvaluateList(queryParamsRef.current, isClear)
    ).then((resp) => {
      resp = resp.data;

      if (parseInt(resp.code) === ApiStatusTypeEnum.COMMON_ERROR) {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  useEffect(() => {
    const storedUserPermission = JSON.parse(
      localStorage.getItem("permissions")
    );
    if (storedUserPermission) {
      storedUserPermission.forEach((permission) => {
        switch (permission.permissioncode) {
          case "membersetting":
            setMemberSettingPermission(permission.allow);
            break;
          default:
            break;
        }
      });
    }
  }, []);

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <MemberList
        selMemberId={selMemberId}
        isMemberDetailsVisible={!!selMemberId}
        memberSettingPermission={memberSettingPermission}
        onClose={() => {
          setSelMemberId(null);
        }}
        onSuccessUpdate={() => handleSearchClick(undefined, false)}
      />
      <div>
        <h2>{intl.formatMessage({ id: "vipEvaluate" })}</h2>
      </div>
      <div className="d-flex align-items-end gap-2">
        <div>
          {intl.formatMessage({ id: "date" })}
          <div className="d-flex justify-content-between">
            <DateRangeComp
              initialRange={[
                { startDate: fromDate, endDate: toDate, key: "selection" },
              ]}
              onDateChange={handleDateChange}
            />
          </div>
        </div>
        <div>
          {intl.formatMessage({ id: "direction" })}
          <div>
            <select
              className="dropdown respond-Select m-0 py-2"
              value={selectedDirectionBaseOn}
              onChange={(e) => {
                setSelectedDirectionBaseOn(e.target.value);
              }}
            >
              {vipEvaluateState.vipEvaluateUI?.directionBaseOnLists.map(
                (value, index) => (
                  <option key={index} value={value.code}>
                    {value.description}
                  </option>
                )
              )}
            </select>
          </div>
        </div>
        <div className="flex-fill d-flex justify-content-end">
          <button
            className="btn btn-primary"
            onClick={() => handleSearchClick()}
          >
            {intl.formatMessage({ id: "search" })}
          </button>
        </div>
      </div>
      <div
        className="member-div d-flex"
        style={{
          margin: "10px auto",
        }}
      >
        <div className="member-container">
          <div className="table-responsive">
            <table className="member-table">
              <thead className="member-header1">
                <tr className="member-row1">
                  <th className="member-cell hide-on-mobile">
                    {intl.formatMessage({ id: "no" })}
                  </th>
                  <th className="member-cell text-start text-nowrap">
                    {intl.formatMessage({ id: "username" })}
                  </th>
                  <th className="member-cell text-start text-nowrap">
                    {intl.formatMessage({ id: "vipLevel" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "amount" })}
                  </th>
                  <th className="member-cell text-start text-nowrap">
                    {intl.formatMessage({ id: "groupCount" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "action" })}
                  </th>
                </tr>
              </thead>
              <tbody className="member-body">
                {vipEvaluateState.vipEvaluateList?.vipMemberLists ? (
                  vipEvaluateState.vipEvaluateList?.vipMemberLists.length >
                  0 ? (
                    vipEvaluateState.vipEvaluateList?.vipMemberLists.map(
                      (vipMember, index) => (
                        <tr key={index} className="member-row1">
                          <td className="member-cell hide-on-mobile">
                            {index + 1}
                          </td>
                          <td className="member-cell text-start">
                            {vipMember.username}
                          </td>
                          <td className="member-cell text-start">
                            {vipMember.viplevel}
                          </td>
                          <td className="member-cell text-end">
                            {vipMember.amount}
                          </td>
                          <td className="member-cell text-start">
                            {vipMember.groupcount}
                          </td>
                          <td className="member-cell text-end">
                            <button
                              className="btn btn-primary me-1"
                              style={{
                                backgroundColor: "#00FFFF",
                                borderColor: "#00FFFF",
                                color: "black",
                              }}
                              onClick={() => {
                                setSelMemberId(vipMember.memberid);
                              }}
                            >
                              <i className="bi bi-exclamation-circle" />
                            </button>
                          </td>
                        </tr>
                      )
                    )
                  ) : (
                    <tr>
                      <td colSpan="6">
                        <div className="no-record-wrapper oRecordDiv">
                          <i className="bi bi-search fs-1 mb-3" />
                          <div className="text-font2">
                            {intl.formatMessage({ id: "noRecordFound" })}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )
                ) : (
                  <tr>
                    <td colSpan="6">
                      <div className="d-flex align-item-center justify-content-center py-2">
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
